<template>
  <section class="section_questions">
    <h2 class="title_bid_form">
      ЧАСТО ЗАДАВАЕМЫЕ <span class="color_orange">ВОПРОСЫ</span>
    </h2>

    <div class="container_questions">
      <!-- ✅ Первый блок (первые 3 вопроса) -->
      <div class="question_block">
        <div
          class="box_question"
          v-for="question in firstBlockQuestions"
          :key="question.id"
        >
          <div class="box_title_question" @click="toggleQuestion(question.id)">
            <img
              src="@/assets/img/icon/top_bottom.svg"
              class="top_bottom"
              :class="{ rotated: openQuestionId === question.id }"
            />
            <p class="title_question">{{ question.title }}</p>
            <p class="number_questio">{{ question.id }}</p>
          </div>
          <p
            class="main_text_question"
            v-if="openQuestionId === question.id"
            v-html="question.text"
          ></p>
        </div>
      </div>

      <!-- ✅ Второй блок (вопросы 4 и 5) -->
      <div class="question_block">
        <div
          class="box_question"
          v-for="question in secondBlockQuestions"
          :key="question.id"
        >
          <div class="box_title_question" @click="toggleQuestion(question.id)">
            <img
              src="@/assets/img/icon/top_bottom.svg"
              class="top_bottom"
              :class="{ rotated: openQuestionId === question.id }"
            />
            <p class="title_question">{{ question.title }}</p>
            <p class="number_questio">{{ question.id }}</p>
          </div>
          <p
            class="main_text_question"
            v-if="openQuestionId === question.id"
            v-html="question.text"
          ></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, computed } from "vue";

export default {
  setup() {
    const questions = ref([
      {
        id: "01",
        title: "Почему стоит выбрать корпусную мебель на заказ?",
        text: "Разнообразие готовых моделей на мебельном рынке позволяет выбрать мебель, которая казалось бы должна хорошо вписаться в готовый интерьер, но так бывает не всегда, поэтому мы рекомендуем выбирать корпусную мебель на заказ, которая идеально подчеркнет дизайнерский замысел вашего готового интерьера.",
      },
      {
        id: "02",
        title: "Как формируется цена на мебель?",
        text: "Стоимость мебели зависит от: материала фасадов и корпуса, размеров, наполнения, фурнитуры и конфигурации. Мы изготовим качественную мебель исходя из вашего бюджета.",
      },
      {
        id: "03",
        title: "Есть ли у вас гарантия на изделия?",
        text: "Обычно мебельные компании не дают гарантии на корпусную мебель на заказ, но мы о вас заботимся и предоставляем гарантию 1 год на все наши изделия.",
      },
      {
        id: "04",
        title: "Кто произведет обмер помещения и установку мебели?",
        text: "В нашей компании трудятся только опытные специалисты, которые произведут все необходимые замеры, учтут особенности помещения и предложат оптимальное решение, для создания мебели с учетом ваших требований и пожеланий. А когда мебель будет готова мы доставим её в ваш дом и произведем монтаж гарантируя полную удовлетворенность заказчика.",
      },
      {
        id: "05",
        title:
          "Выполняем ли мы заказы для Ленинградской области?",
        text: "Клиенты нашей компании всегда могут воспользоваться услугой выезда дизайнера-проектировщика. На месте наш специалист произведет точный замер, составит эскиз будущей мебели с последующей 3D визуализацией.",
      },
    ]);

    // Переменная для отслеживания открытого вопроса
    const openQuestionId = ref(null);

    // Разделение вопросов на два блока
    const firstBlockQuestions = computed(() => questions.value.slice(0, 3));
    const secondBlockQuestions = computed(() => questions.value.slice(3, 5));

    // Функция для открытия/закрытия вопроса
    const toggleQuestion = (id) => {
      openQuestionId.value = openQuestionId.value === id ? null : id;
    };

    return {
      firstBlockQuestions,
      secondBlockQuestions,
      openQuestionId,
      toggleQuestion,
    };
  },
};
</script>
<style>
.container_questions {
  display: flex;
  justify-content: flex-end;
  gap: 10rem;
  row-gap: 0px;
}
.section_questions {
  display: flex;
  padding: 6rem 8rem;
  background: rgb(255, 255, 255);
  gap: 1.5rem;
  flex-direction: column;
}
.title_bid_form {
  font-family: Roboto;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.9rem;
  letter-spacing: 1.5%;
  text-align: left;
  text-transform: uppercase;
}
.box_question {
  width: 29.65rem;
  padding: 2rem 0;
  border-bottom: 0.05rem solid rgb(167, 161, 156);
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  transition: 0.2s ease;
}
.box_title_question {
  position: relative;
  display: flex;
  gap: 1.4rem;
  align-items: center;
  padding-right: 5rem;
}
.top_bottom {
  width: 1.55rem;
  height: 0.45rem;
  object-fit: cover;
}
.title_question {
  color: rgb(25, 24, 24);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.4rem;
  letter-spacing: -1%;
  text-align: left;
}
.number_questio {
  position: absolute;
  color: rgb(245, 160, 62);
  font-family: Roboto;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.4rem;
  letter-spacing: -1%;
  text-align: left;
  right: 0px;
  top: 0px;
}
.main_text_question {
  margin-left: 3rem;
  color: rgb(25, 24, 24);
  font-family: Roboto;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 0.95rem;
  letter-spacing: 0%;
  text-align: left;
  transition: 0.2s ease;
}
@media (max-width: 767px) {
  .section_questions {
    padding: 4rem 2.4rem 4rem 2.4rem;
  }
  .container_questions {
    flex-direction: column;
  }
  .box_question {
    width: 100%;
  }
  .title_bid_form {
    font-size: 1.43rem;
    font-weight: 700;
    line-height: 1.64rem;
  }
  .title_question {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.14rem;
  }
  .box_title_question {
    padding-right: 3rem;
  }
  .number_questio {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.14rem;
  }
}
</style>
